if (!customElements.get('gift-box-offer')) {
  class GiftBoxOffer extends HTMLElement {
    constructor() {
      super();
      this.onAddClick = this.onAddClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('.gift-box-offer__add');
      this.text = this.querySelector('.gift-box-offer__text');
      this.progress = this.querySelector('.gift-box-offer__progress-bar');
      this.defaultText = this.text?.dataset.defaultText || '';
      this.freeText = this.text?.dataset.freeText || this.defaultText;

      const currencyRate = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? Shopify.currency.rate : 1;
      this.total = parseInt(this.dataset.cartTotal, 10) || 0;
      this.minimum = Math.round((parseInt(this.dataset.minimum, 10) || 0) * currencyRate);

      this.updateState();

      if (this.button && !this.button.disabled) {
        this.button.addEventListener('click', this.onAddClick);
      }
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.onAddClick);
      }
    }

    updateState() {
      const qualified = this.minimum === 0 || this.total >= this.minimum;
      const percentage = this.minimum > 0 ? Math.min(this.total / this.minimum, 1) : 1;

      this.style.setProperty('--gift-box-percentage', percentage);

      if (this.text) {
        this.text.textContent = qualified ? this.freeText : this.defaultText;
      }

      this.classList.toggle('gift-box-offer--qualified', qualified);
    }

    onAddClick(event) {
      event.preventDefault();
      if (!this.button || this.button.classList.contains('loading')) {
        return;
      }

      const variantId = this.button.dataset.variantId;
      if (!variantId) {
        return;
      }

      this.button.classList.add('loading');
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', ['cart-drawer', 'cart-bubble', 'main-cart']);
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderSections(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML || '';
    }

    renderSections(parsedState) {
      const sections = [
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        },
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        }
      ];

      sections.forEach((section) => {
        const container = document.getElementById(section.id);
        const html = parsedState.sections?.[section.section];

        if (!container || !html) {
          return;
        }

        const target = container.querySelector(section.selector) || container;
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);

        if (section.id === 'Cart-Drawer') {
          container.notesToggle?.();
          container.removeProductEvent?.();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });

      const drawer = document.getElementById('Cart-Drawer');
      if (drawer) {
        drawer.classList.add('active');
        document.body.classList.add('open-cart', 'open-cc');
        drawer.querySelector('.product-recommendations--full')?.classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
  }

  customElements.define('gift-box-offer', GiftBoxOffer);
}
